import React, {useEffect, useRef, useState} from 'react'
import {useHistory} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {useWebSocketContext} from '../../../../app/context/WebSocketContext'
import {useUserNotifications} from '../../../../app/hooks/notifications/useNotifications'
import {useUserProfileContext} from '../../../../app/context/UserProfileContext'
import {GlobalSearch} from './search/GlobalSearch'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import { defaultLogoNameBlackSVG, defaultProfileImage } from '../../../../app/utils/constants'
import { hasRole } from '../../../../app/utils/permissions'
import { UserRole } from '../../../../app/constants/roles'
import SVG from 'react-inlinesvg'
import { showErrorAlert } from '../../../../app/helpers/alert'

export function HeaderWrapper() {
  const {config, attributes} = useLayout()
  const {aside} = config
  const {subscribe, isConnected} = useWebSocketContext()
  const {data, searchParams} = useUserProfileContext()
  const loggedUser = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [random, setRandom] = useState(Math.random() * 30)
  const {data: initialNotifications} = useUserNotifications()
  const [notificationCount, setNotificationCount] = useState(0)
  const [hasNewNotification, setHasNewNotification] = useState(false)
  const navigate = useHistory()
  const [openUserMenu, setOpenUserMenu] = useState(false)
  const [openNotificationMenu, setOpenNotificationMenu] = useState(false)
  const userMenuRef = useRef<HTMLDivElement>(null)
  const notificationMenuRef = useRef<HTMLDivElement>(null)
    const hasAdminRole = hasRole(loggedUser, UserRole.ADMIN) || hasRole(loggedUser, UserRole.STAFF_USER) || hasRole(loggedUser, UserRole.PARTNER) || hasRole(loggedUser, UserRole.PROFILE_MANAGEMENT) || hasRole(loggedUser, UserRole.TEAM)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target as Node)
      ) {
        setOpenUserMenu(false)
      }
    }
    const handleClickOutsideNotification = (event: MouseEvent) => {
      if (
        notificationMenuRef.current &&
        !notificationMenuRef.current.contains(event.target as Node)
      ) {
        setOpenNotificationMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('mousedown', handleClickOutsideNotification)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('mousedown', handleClickOutsideNotification)
    }
  }, [])

  useEffect(() => {
    if (initialNotifications && Array.isArray(initialNotifications)) {
      const unreadCount = initialNotifications.filter((n) => !n.isRead).length
      setNotificationCount(unreadCount)
    }
  }, [initialNotifications])

  useEffect(() => {
    if (!isConnected) return

    const unsubscribe = subscribe('notification', (data) => {
      console.log('Nueva notificación en header:', data)

      if (!data.is_read && data.is_read !== undefined) {
        setNotificationCount((prev) => prev + 1)
      } else {
        setNotificationCount((prev) => prev + 1)
      }

      setHasNewNotification(true)

      setTimeout(() => {
        setHasNewNotification(false)
      }, 500)
    })

    return () => {
      unsubscribe()
    }
  }, [subscribe, isConnected])

  useEffect(() => {
    setRandom(Math.random() * 10)
  }, [data])

  const handleNotificationRead = () => {
    setNotificationCount((prev) => Math.max(0, prev - 1))
  }

  const isTeamMember = hasRole(loggedUser, UserRole.TEAM)

  const profilePicture = searchParams.userSelected
    ? loggedUser.profilePicture
    : data?.profilePicture
  const headerPicture = isTeamMember ? (data?.profilePicture || loggedUser.actingFor?.profilePicture) : profilePicture
  const headerName = isTeamMember && data
    ? `${data.firstName} ${data.lastName}`
    : isTeamMember && loggedUser.actingFor
    ? `${loggedUser.actingFor.firstName} ${loggedUser.actingFor.lastName}`
    : `${loggedUser?.firstName} ${loggedUser?.lastName}`

  return (
    <div
      id='kt_header'
      className={clsx('header nb-header align-items-center')}
      style={{
        width: '100%',
      }}
      {...attributes.headerMenu}
    >
      {aside.display && (
        <div className='d-flex align-items-center d-lg-none me-1' title='Show aside menu'>
          <div
            className='btn btn-icon btn-active-light w-30px h-30px w-md-40px h-md-40px'
            id='kt_aside_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
          </div>
        </div>
      )}
      <div
        className='container-fluid d-flex align-items-center justify-content-between'
        style={{
          maxWidth: 'none',
          width: '100%',
          paddingLeft: '24px',
          paddingRight: '24px',
        }}
      >
        {/* LOGO */}
        <div
          className='nb-header__logo'
          style={{
            cursor:
              hasRole(loggedUser, UserRole.ADMIN) || hasRole(loggedUser, UserRole.STAFF_USER)
                ? 'pointer'
                : 'default',
          }}
          onClick={() => {
            if (hasRole(loggedUser, UserRole.ADMIN) || hasRole(loggedUser, UserRole.STAFF_USER)) {
              navigate.push('/dashboard/admin')
            }
          }}
        >
          <SVG src={defaultLogoNameBlackSVG} width={78} height={15} />
        </div>

        {/* CENTRO */}
        <div className={`nb-header__center ${hasRole(loggedUser,UserRole.FINAL_USER) ? '' : 'd-none'}`}>
          <GlobalSearch />
        </div>

        {/* DERECHA */}
        <div className='nb-header__right'>
          <span className={`nb-header__right-link ${hasRole(loggedUser,UserRole.FINAL_USER) ? '' : 'd-none'}`}>Community</span>
          <span  className={`nb-header__right-link ${hasRole(loggedUser,UserRole.FINAL_USER) ? '' : 'd-none'}`}>Expertise</span>

          {/* NOTIFICATIONS */}
          <div className={`nb-header__right-avatar ${hasRole(loggedUser,UserRole.FINAL_USER) ? '' : 'd-none'}`} ref={notificationMenuRef}>
            <div className='notification-icon-wrapper cursor-pointer' onClick={() => /* showErrorAlert({ title: 'Coming Soon', message: '' }) */ setOpenNotificationMenu((prev) => !prev)}>
              <KTSVG path='/media/svg/nobilis/bell.svg' />

              {notificationCount > 0 && (
                <div
                  className={`notification-badge ${
                    hasNewNotification ? 'notification-badge--new' : ''
                  }`}
                >
                  <span className='notification-badge__number'>
                    {notificationCount > 99 ? '99+' : notificationCount}
                  </span>
                </div>
              )}
            </div>
            <HeaderNotificationsMenu open={openNotificationMenu} onNotificationRead={handleNotificationRead} />
          </div>

          {/* USER MENU */}
          <div className={clsx('nb-header__right-avatar position-relative', {'admin': hasRole(loggedUser,UserRole.ADMIN) })} ref={userMenuRef}>
            <div className='cursor-pointer avatar-wrapper' onClick={() => setOpenUserMenu((prev) => !prev)}>
              <img src={ headerPicture ? `${headerPicture}?t=${random}` : defaultProfileImage } onError={(e)=>{e.currentTarget.src = defaultProfileImage}} alt='User'/>
              <span className={`slider-label fw-bold pl_3${hasAdminRole ? '' : ' d-none'}`}>{headerName}</span>
            </div>
            <HeaderUserMenu open={openUserMenu} onClose={() => setOpenUserMenu(false)} />
          </div>
        </div>
      </div>
    </div>
  )
}
